import { ImagePickerService } from './image-picker.service';

export default angular
  .module('sfMobile.services.image-picker', [
    'sfMobile.components.popup-download',
    'pascalprecht.translate',
  ])
  .service('imagePickerService', ImagePickerService).name;
